import React, { useContext } from "react";

import { useTranslation } from "react-i18next";

import { EventBodyTabs } from "@data-types/offer/event/EventViewStoreEnums";
import { OfferStoreContext } from "@gp/components";
import EventViewStore from "@state/stores/offer/event/EventViewStore";
import { observer } from "mobx-react";

export const EventFooterCore = observer(function EventFooterCore() {
	const { t } = useTranslation();
	const store = useContext(OfferStoreContext) as EventViewStore;

	if (store.currentTab !== EventBodyTabs.Markets) {
		return null;
	}

	if (
		store.displayBettingGroup != "all" ||
		store?.bettingTypeGroups?.length === 0
	) {
		return null;
	}

	if (
		!store.isExpanded &&
		store.defaultBettingTypesCount == store?.keyOffersMap?.size
	) {
		return null;
	}

	if (store.isExpanded) {
		return (
			<div className="event__footer">
				<button
					type="button"
					className="event__footer__btn btn btn--sml btn--block btn--ghost btn--icon btn--animate-rotate-down"
					onClick={() => {
						store.toggleShowMore();
						document
							?.getElementById(`event-${store.eventId}`)
							?.scrollIntoView({
								behavior: "smooth",
								block: "start",
							});
					}}
				>
					{t("COMMON.CLOSE")}
					<i className="u-icon u-icon--tny u-icon--caret--up" />
				</button>
			</div>
		);
	}

	return (
		<div className="event__footer">
			<button
				type="button"
				className="event__footer__btn btn btn--sml btn--block btn--ghost btn--icon btn--animate-rotate-down"
				onClick={store.toggleShowMore}
			>
				{t("COMMON.SHOW_MORE")}
				<i className="u-icon u-icon--tny u-icon--caret--right" />
			</button>
		</div>
	);
});
